import { Component, Input, OnInit } from '@angular/core';
import DataSlotFirstPageModel from '../../models/data-slot-first-page.model';
import { BundleDetailsModalService } from '../../services/bundle-details-modal.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { ProcessTypeEnum } from '../../models/cartDetails/process-type.enum';
import { BundleTypeEnum } from '../../models/cartDetails/bundle-type.enum';
import AuthProcessSwitcherService from '../auth/auth-process-switcher.service';

@Component({
  selector: '[new-offer-data-slot]',
  templateUrl: './new-offer-data-slot.component.html',
})
export class NewOfferDataSlotComponent implements OnInit {
  public isDetailsLinkVisible = false;
  public accessoryItemElementWarning = false;
  public noOffer = false;
  public offerNoDevice = false;
  public offerWithDevice = false;
  public showProcessInput: boolean;
  public slotFactory: AuthProcessSwitcherService;

  @Input('slotData') slot: DataSlotFirstPageModel;

  @Input() header: string;

  constructor(
    public commonInfo: CommonInfoService,
    private bundleDetailsModalService: BundleDetailsModalService,
  ) {
  }

  ngOnInit() {
    this.isDetailsLinkVisible = this.slot.device?.bundledDevice;

    if (this.slot.isTrafficTypeVoice()) {
      const isSolo = this.commonInfo.isSolo;

      this.slotFactory = new AuthProcessSwitcherService(this.slot);
      this.showProcessInput = (isSolo && !this.slot.isTrafficTypeTV()) || this.slot.processType === ProcessTypeEnum.RETENTION || (this.slot.bundleType === BundleTypeEnum.ADDITIONAL_OFFER && this.slot.isTrafficTypeVoice());
    }

    this.updateClasses();
  }

  public showDetails(event: Event) {
    event.preventDefault();

    const deviceId = this.slot.device.sku;

    const msisdn = this.slot.getMsisdn();

    this.bundleDetailsModalService.showDetailsModal(deviceId, msisdn);
  }

  private updateClasses() {
    this.accessoryItemElementWarning = this.slot.isWarningVisible;
    this.noOffer = this.slot.ifNoOffer;
    this.offerNoDevice = this.slot.ifOfferHasNoDevice;
    this.offerWithDevice = this.slot.ifOfferHasDevice;
  }
}
